module.exports = __webpack_public_path__ + "media/images/character/zen_chan_hands_up-0c9718fe926158e27758bd365fb2fff2.png";